import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MRVComponent } from './mrv.component';

const routes: Routes = [
  {
    path: '',
    component: MRVComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MRVRoutingModule {}
